import { render, staticRenderFns } from "./CardTestimonial.vue?vue&type=template&id=7319834a&scoped=true"
import script from "./CardTestimonial.js?vue&type=script&lang=js&external"
export * from "./CardTestimonial.js?vue&type=script&lang=js&external"
import style0 from "./CardTestimonial.scss?vue&type=style&index=0&id=7319834a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319834a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default})
